import { render, staticRenderFns } from "./MemberAddress.vue?vue&type=template&id=215ac386&scoped=true&"
import script from "./MemberAddress.vue?vue&type=script&lang=js&"
export * from "./MemberAddress.vue?vue&type=script&lang=js&"
import style0 from "./MemberAddress.vue?vue&type=style&index=0&id=215ac386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ac386",
  null
  
)

export default component.exports